import { Link } from "react-router-dom";
import { COMPANY } from "../lib/data";

export const Logo = ({ light = false, className = "" }) => (
  <Link to="/" className={`inline-flex items-center ${className}`} data-testid="logo-link" aria-label="AUM home">
    <img
      src={light ? COMPANY.logoWhite : COMPANY.logoBlack}
      alt="AUM Building Science & Engineering Ltd."
      className="h-11 md:h-12 w-auto object-contain"
      draggable={false}
    />
  </Link>
);
